import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageHeader from '../../../components/owner/PageHeader';
import BranchForm from './BranchForm';
import { fetchBranchById, saveBranch } from '../../../services/gym/catalogApi';
import { usePanelToast } from '../../../context/PanelToastContext';
import '../../owner/ownerPages.css';
import './branches.css';

function EditBranch() {
  const toast = usePanelToast();
  const { id } = useParams();
  const navigate = useNavigate();
  const [branch, setBranch] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const data = await fetchBranchById(id);
        if (active) setBranch(data);
      } catch (err) {
        if (active) setError(err.message || 'Failed to load branch');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [id]);

  if (loading) {
    return <p className="owner-placeholder-text">Loading branch...</p>;
  }

  if (!branch) {
    navigate('/admin/branches', { replace: true });
    return null;
  }

  const handleSubmit = async (form) => {
    try {
      await saveBranch(form, id);
      toast.showUpdated('Branch');
      navigate('/admin/branches');
    } catch (err) {
      setError(err.message || 'Failed to update branch');
    }
  };

  return (
    <div>
      <PageHeader title="Edit Branch" subtitle={`Editing: ${branch.name}`} />
      {error && <p className="owner-placeholder-text owner-mb-16">{error}</p>}
      <div className="owner-card branch-form-card">
        <BranchForm
          initialData={{
            name: branch.name,
            location: branch.location,
            address: branch.address,
            manager: branch.manager,
            phone: branch.phone,
            status: branch.status,
          }}
          submitLabel="Save Changes"
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/branches')}
        />
      </div>
    </div>
  );
}

export default EditBranch;
